import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import Social from "../Forms/G/Social/Social"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const SocialContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, loadCollection, handleLoadPrev } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingSocial, setIsGettingSocial] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingSocial(true)
      handleSubmitGet(endpoints.GET_SOCIAL_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SOCIAL,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.SOCIAL)
          handleLoadPrev(false)
          setIsGettingSocial(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingSocial(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_g_1: data?.form?.gpraG1 ?? "",
      gpra_g_1_num: data?.form?.gpraG1Num ?? 0,
      gpra_g_2: data?.form?.gpraG2 ?? "",
      gpra_g_3: data?.form?.gpraG3 ?? "",
      gpra_g_4: data?.form?.gpraG4 ?? "",
      gpra_g_id: data?.form?.gpraGId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingSocial) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingSocial && (
        <Social showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default SocialContainer
